import { motion } from "framer-motion";
import { PRODUCTS, WHATSAPP_URL } from "../data/site";

const ProductCard = ({ p, i }) => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`product-card-${p.id}`}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: (i % 2) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative block ${p.span} bg-card border border-border overflow-hidden`}
  >
    <div className="overflow-hidden">
      <img
        src={p.image}
        alt={p.name}
        className="w-full h-64 md:h-80 object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
      />
    </div>
    <div className="p-6 md:p-8">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="overline mb-2">{p.index}</p>
          <h3 className="font-heading text-3xl md:text-4xl leading-none">{p.name}</h3>
          <p className="text-sm text-accent mt-2 tracking-wide">{p.tagline}</p>
        </div>
        <span className="shrink-0 mt-1 h-10 w-10 rounded-full border border-border flex items-center justify-center text-foreground/70 group-hover:bg-foreground group-hover:text-primary-foreground transition-colors duration-300">
          →
        </span>
      </div>
      <p className="text-base leading-relaxed text-foreground/60 mt-4 max-w-xl">
        {p.description}
      </p>
    </div>
  </motion.a>
);

export const Products = () => {
  return (
    <section id="collection" data-testid="products-section" className="py-24 md:py-40 bg-[#FFFFFF]">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
          <div>
            <p className="overline mb-5">The Collection</p>
            <h2 className="font-heading font-light text-5xl md:text-7xl tracking-tight leading-[0.95] max-w-2xl">
              Eight ways to sleep <span className="italic text-accent">better.</span>
            </h2>
          </div>
          <p className="text-base md:text-lg text-foreground/60 max-w-sm">
            Every product is manufactured in-house and made to order. Tap any card
            to enquire on WhatsApp.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.id} p={p} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
